import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-layout-background',
  templateUrl: './layout-background.component.html',
  styleUrls: ['./layout-background.component.sass']
})
export class LayoutBackgroundComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
